<template>
  <div>
    <Message type="info">
      この情報で問題なければ、キャンペーンチェック項目を確認して保存ボタンをクリックしてください。
    </Message>

    <div class="tiktok-confirm-section">
      <Panel>
        <div class="section-title">基本設定</div>

        <div class="section-item">
          実施アカウント
          <div class="section-item-content">
            <Account v-if="account" :name="account.name" :image="account.picture_url" :symbol="account.target_sns" />
          </div>
        </div>

        <div class="section-item">
          キャンペーンタイトル
          <div class="section-item-content">
            {{ form.title }}
          </div>
        </div>

        <div class="section-item">
          キャンペーン期間
          <div class="section-item-content">
            {{ campaign_period }}
          </div>
        </div>
      </Panel>
    </div>

    <div class="tiktok-confirm-section">
      <Panel>
        <div class="section-title">応募条件</div>

        <div class="section-item">
          キャンペーンタイプ
          <div class="section-item-content">
            {{ campaign_type_options }}
          </div>
        </div>

        <div class="section-item">
          以下のキャンペーンハッシュタグ全てを含む
          <div class="section-item-content tag-container">
            <Tags :value="form.keywords" />
          </div>
        </div>
      </Panel>
    </div>

    <div class="confirm-footer">
      <el-button @click="prevStep">
        <Icon name="arrow-left" space="right" />
        戻る
      </el-button>
      <div class="footer-right">
        <el-button @click="cancel"> キャンセル </el-button>
        <el-button type="primary" :disabled="is_submit" @click="saveCampaign"> 保存 </el-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment-timezone'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import Message from '@/client/components/_atoms/Message.vue'
import Panel from '@/client/components/_atoms/Panel.vue'
import Account from '@/client/components/_molecules/Account.vue'
import Tags from '@/client/components/_molecules/Tags.vue'
import { TIKTOK_ENTRY_ACTION_TYPES } from '@/client/constant'
import { TrackingService } from '@/client/services'
import { useCampaignDialogStore } from '@/client/store/useCampaignDialogStore'
import { CAMPAIGN_START_DATETIME_INVALID, MAX_CAMPAIGN_COUNT_OVER } from '@/server/constants/error'

export default defineComponent({
  components: {
    Icon,
    Message,
    Panel,
    Account,
    Tags
  },
  data() {
    return {
      is_submit: false
    }
  },
  computed: {
    ...mapState(useCampaignDialogStore, ['form', 'api_accounts']),
    account() {
      return this.api_accounts.find(v => v.id === this.form.account_id && v.target_sns === 'tiktok')
    },
    campaign_type_options() {
      return TIKTOK_ENTRY_ACTION_TYPES.label
    },
    campaign_period() {
      const start_date = this.form.start_date
        ? moment(this.form.start_date).format('YYYY年MM月DD日') + ' ' + this.form.start_time
        : ''

      const end_date = this.form.end_date
        ? moment(this.form.end_date).format('YYYY年MM月DD日') + ' ' + this.form.end_time
        : ''

      return start_date + ' - ' + end_date
    }
  },
  methods: {
    ...mapActions(useCampaignDialogStore, ['prevStep', 'createCampaign']),
    cancel(payload) {
      this.$emit('cancel', payload)
      return payload
    },
    /**
     * キャンペーンを保存する
     */
    async saveCampaign() {
      TrackingService.sendEvent('click:キャンペーンの新規作成|確認|保存')

      if (this.is_submit) {
        return
      }

      this.is_submit = true

      const result = await this.createCampaign()

      this.is_submit = false

      if (result.data && result.data.id) {
        this.$emit('complete', result.data.id)
        return
      }

      if (result.error && result.error.type === MAX_CAMPAIGN_COUNT_OVER.type) {
        this.$notify({
          title: 'キャンペーンの作成に失敗しました。',
          message: '同時開催可能件数を超えるため、指定の期間ではキャンペーンを開催できません。',
          customClass: 'danger'
        })
        return
      }

      if (result.error && result.error.type === CAMPAIGN_START_DATETIME_INVALID.type) {
        this.$notify({
          title: 'キャンペーンの作成に失敗しました。',
          message: 'キャンペーン開始日時は、現在日時より後を指定してください。',
          customClass: 'danger'
        })
        return
      }

      this.$notify({
        title: 'キャンペーンの作成に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger'
      })
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.tiktok-confirm-section {
  margin-top: $spacing-unit * 2;

  .section-title {
    font-weight: bold;
  }

  .section-item {
    margin-top: $spacing-unit * 3;

    .section-item-content {
      margin-top: $spacing-unit;

      &:not(.tag-container) {
        font-size: $font-large-size;
      }
    }
  }
}

.confirm-footer {
  display: flex;
  justify-content: space-between;
  margin-top: $spacing-unit * 3;
}

.footer-right {
  display: flex;
}
</style>
